import React, { useState, useEffect, useRef, useCallback } from 'react'
import styled from 'styled-components'
//@ts-ignore
import Modal from 'live/components/ui/Modal'
import { useSelector, useDispatch } from 'react-redux'
// components preview
import HeaderCell from './HeaderCell'
import HeaderFormat from './HeaderFormat'
import Cell from './Cell'
import { SpreadsheetHeader } from '../main/options/model/types'

interface Props {
    onlyView?: boolean
    update?: boolean
    database?: string
    getHeader?: boolean
    headers: SpreadsheetHeader[]
}

export default function ModalPreview({ headers, onlyView = true, update = false, database, getHeader = false }: Props) {
    useEffect(() => {}, [database])

    const containerRef = useRef(null)

    useEffect(() => {
        document.addEventListener('mousewheel', onWhell, { passive: false })
        return () => {
            document.removeEventListener('mousewheel', onWhell)
        }
    }, [])

    const onWhell = event => {
        if (containerRef.current && containerRef.current.contains(event.target)) {
            const containerScrollPosition = containerRef.current.scrollLeft
            containerRef.current.scrollTo({
                top: 0,
                left: containerScrollPosition + event.deltaY,
                behaviour: 'smooth'
            })
        }
    }

    return (
        <>
            <div
                ref={containerRef}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'scroll',
                    height: '90%',
                    overflowY: 'hidden',
                    background: 'var(--gray-300)',                    
                }}
            >                
                <div className="sheet-preview">
                    <div className="sheet-stage">
                        <div className="shadow" style={{backgroundColor:'var(--gray-100)'}}>
                            <table className="sheet">
                                <thead>
                                    <tr>
                                        <th className="no-border"></th>
                                        {headers.map((cell, cellId) => (
                                            <HeaderCell
                                                sheet={0}
                                                cell={cell}
                                                key={cellId}                                                
                                                onlyView={onlyView}
                                                update={update}                                                                                                
                                                // updatedSuccessfully={updatedSuccessfully}
                                                
                                            />
                                        ))}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        {headers.map((cell, cellId) => (
                                            <HeaderFormat
                                                sheet={0}                                                
                                                cell={cell}
                                                key={cellId}
                                                update={update}
                                                onlyView={onlyView}
                                                outsideClickIgnoreClass="rc-menu-item"
                                            />
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* linha */}
                                    {[...Array(25)].map((_, rowId) => (
                                        <tr key={rowId}>
                                            <td>{rowId + 1}</td>
                                            {/* coluna */}
                                            {headers.map((_, cellId) => (
                                                <Cell
                                                    key={cellId}
                                                    value="----"
                                                    // isDisabled={false}
                                                    isDisabled={headers[cellId].isDisabled}
                                                />
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
